/**
 * This pull quotes component is used to voice the thoughts of customers of the instructions of stylists of other Ulta Beauty state.
 *
 * @module views/components/PullQuote
 * @memberof -Common
 */
import './PullQuote.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Text from '@ulta/core/components/Text/Text';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { useDeviceInflection } from '@ulta/core/providers/InflectionProvider/InflectionProvider';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a PullQuote component
 *
 * @method
 * @param {PullQuoteProps} props - React properties passed from composition
 * @returns PullQuote
 */
export const PullQuote = function( props ){
  const { breakpoint } = useDeviceInflection();
  return (
    <div className='PullQuote'>
      <div className={ classNames( 'PullQuote__content', {
        'PullQuote__content--emptyImage': !props.image,
        'PullQuote__content--pullQuoteImagePosition': props.quoteImage
      } )
      }
      >
        <div className='PullQuote__leftcolumn'>
          {
            props.quoteImage &&
            <div className={ classNames( {
              'PullQuote__image--empty': !props.image,
              'PullQuote__quoteImage': props.image
            } )
            }
            >
              <UltaAsset
                { ...spreadProps( { ...props.quoteImage } ) }
                width={ breakpoint.CURRENT_BREAKPOINT === 'XS' && !props.image ? 40 : 80 }
              />
            </div>
          }
          {
            props.image &&
            <div className='PullQuote__image' >
              <UltaAsset
                { ...spreadProps( { ...props.image } ) }
              />

            </div>
          }
        </div>
        <div className={ classNames( 'PullQuote__rightcolumn', {
          'PullQuote__rightcolumn--empty': !props.image
        } )
        }
        >
          {
            props.eyebrow &&
            <div className='PullQuote__eyebrow'>
              <Text
                htmlTag='p'
                textStyle='eyebrow'
                textAlign={ !props.image ? 'center' : 'left' }
              >
                { props.eyebrow }
              </Text>
            </div>
          }
          {
            props.subtitle &&
            <div className='PullQuote__subtitle'>
              <Text
                htmlTag='p'
                textStyle='subtitle-1'
                textAlign={ !props.image ? 'center' : 'left' }
              >
                { props.subtitle }
              </Text>
            </div>
          }
          {
            props.author &&
            <div className='PullQuote__author'>
              <Text
                htmlTag='p'
                textStyle='body-1'
                textAlign={ !props.image ? 'center' : 'left' }
              >
                { props.author }
              </Text>
              <Text
                htmlTag='p'
                textStyle='body-1'
                textAlign={ !props.image ? 'center' : 'left' }
              >
                { props.authorTitle }
              </Text>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

/**
  * Property type definitions
  * @typedef PullQuoteProps
  * @type {object}
  * @property {object} Image - Sets the  image
  * @property {string} eyebrow - Sets the eyebrow text
  * @property {object} quoteImage - Sets the quoteImage
  * @property {string} author - Sets the author
  * @property {string} subtitle  - Sets the subtitle  text
  * @property {string} authorTitle - Sets the authorTitle
*/

export const propTypes = {
  /** Sets the Image for display */
  image: PropTypes.object,
  /** Sets the eyebrow for display */
  eyebrow: PropTypes.string,
  /** Sets the subtitle  for display */
  subtitle: PropTypes.string,
  /** Sets the quoteImage  for display */
  quoteImage: PropTypes.object,
  /** Sets the author  for display */
  author: PropTypes.string,
  /** Sets the authorTitle  for display */
  authorTitle: PropTypes.string
};

PullQuote.propTypes = propTypes;

export default PullQuote;
